import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Icon } from 'semantic-ui-react';
import AsyncSelect from 'react-select/async';
import moment from 'moment';
import ConfirmActionModal from 'components/ui/ConfirmActionModal';
import { AttachmentsFromOtherLots } from './AttachmentsFromOtherLots';

export const customStyles = {
  container: (provided: any) => ({
    ...provided,
    width: 295,
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    boxShadow: state.isFocused && '1px solid #ff5252',
    border: state.isFocused ? '1px solid #ff5252' : '1px solid #e5e5ea',
    height: 48,
    '&:hover': {
      border: state.isFocused && '1px solid #ff5252',
    },
  }),
};

const defaultProperty: PropertyOption = {
  value: 0,
  label: '',
};

interface PropertyOption {
  label: string;
  value: number;
}

interface PropertyWithOrderInfo {
  id: number;
  address: string;
  orderId: number;
  section: string;
  block: string;
  lot: string;
  qualifier: string;
  titleNumber: string;
  lastUpdated: Date;
}

interface PropTypes {
  propertyId: number;
  searchTypeId: number;
  setSelectedProperty?: (e: any) => void;
  setDocumentKey?: () => void;
  orderId: number;
  showIcon: boolean;
  locationTypeId: number;
}

export const InfoFromPastOrders = (props: PropTypes) => {
  const [selectedProperty, setSelectedProperty] = useState<PropertyOption>();
  const [displayConfirmModal, setDisplayConfirmModal] = useState(false);
  const [showActions, setShowActions] = useState(false);
  const [attachmentsKey, setAttachmentsKey] = useState(1);

  useEffect(() => {
    if (selectedProperty?.value) {
      setAttachmentsKey(attachmentsKey + 2);
    }
  }, [selectedProperty?.value]);

  const createOption = (property: PropertyWithOrderInfo) => ({
    ...property,
    value: property.id,
    label: `HDS${property.orderId} - ${property.titleNumber} - ${property.address} - ${
      property.section ? property.section + '-' : ''
    }${property.block}-${property.lot}${property.qualifier ? '-' + property.qualifier : ''} - ${moment(
      property.lastUpdated
    ).format('MM/DD/YYYY')}`,
  });

  const loadPropertiesOptions = async (value: string) => {
    const { data } = await axios.get<PropertyWithOrderInfo[]>(
      `/api/property/propertySearch?searchTerm=${value}&searchTypeId=${+props.searchTypeId}&locationTypeId=${
        props.locationTypeId
      }`
    );
    return data.map(createOption);
  };

  const handleSelectedPropertyChange = (item: PropertyOption) => {
    if (item) {
      setSelectedProperty(item);
      setDisplayConfirmModal(true);
    }
  };

  const handleModalClose = () => {
    setDisplayConfirmModal(false);
    setSelectedProperty(defaultProperty);
  };

  const handleModalAction = () => {
    setDisplayConfirmModal(false);
    props.setSelectedProperty && props.setSelectedProperty(selectedProperty);
    setShowActions(true);
  };

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', zIndex: 500 }}>
        <div style={{ width: 200, marginLeft: 18, display: 'flex', flexDirection: 'column' }}>
          <span style={{ marginBottom: 8 }}>
            Get info from past orders {props.showIcon && <Icon name="check circle" color="green" />}
          </span>

          <AsyncSelect
            value={selectedProperty}
            cacheOptions
            loadOptions={loadPropertiesOptions}
            isClearable
            styles={customStyles}
            placeholder="Search by order, address, or SBL"
            onChange={(item: any) => {
              handleSelectedPropertyChange(item);
            }}
          />
        </div>
        {showActions && (
          <AttachmentsFromOtherLots
            key={attachmentsKey}
            setShowActions={setShowActions}
            propertyId={props.propertyId}
            searchTypeId={props.searchTypeId}
            oldPropertyId={selectedProperty.value}
            setDocumentKey={props.setDocumentKey}
          />
        )}
        {displayConfirmModal && (
          <ConfirmActionModal
            openState={displayConfirmModal}
            onClose={handleModalClose}
            header="Overwrite Search Information"
            info="Once saved, all prior information will be overwritten."
            actionFunction={handleModalAction}
            buttonText="Select Property"
            cancelButtonText="Cancel"
          />
        )}
      </div>
    </div>
  );
};
